export const NO_IMAGE_PATH = '/images/fallback_image.webp';

export const FILE_TYPE = { JPG: 'image/jpeg', PNG: 'image/png' };

export const MAX_UPLOAD_FILE_SIZE = 10; // 单位: MB
